module.exports = __webpack_public_path__ + "fonts/playfair-display-v22-latin-700.d76734db.eot";